import {BuildingTypesQuickMode} from '../../../../../../services/inquiry/inquiry-configuration.service';
import {BuildingType} from '../../../../../../models/InquiryModel';
import {FinMatchValidators} from '../../../../../../validators/finmatch-validators';
import {APP_DI_CONFIG} from '../../../../../../app-config.module';
import {LabelsMap, TranslationService} from '../../../../../../services/root/translation/translation.service';
import {UntypedFormGroup, Validators} from '@angular/forms';
import {Component, Input, OnChanges, OnInit} from '@angular/core';

const config = APP_DI_CONFIG;
const customValidators = new FinMatchValidators(config);

export const RealEstateExistingBuildingQuickFormGroup = {
    id: [],
    buildingArea: [null, [customValidators.area7]],
    buildingConstructionYear: [null, [customValidators.yearOfEstValidator()]],
    buildingType: [null, [Validators.required]],
    city: [null, [Validators.required, Validators.maxLength(100)]],
    country: ['GERMANY', [Validators.required]],
    houseNumber: [null, [Validators.maxLength(5)]],
    postalCode: [null, [Validators.max(99999)]],
    propertyArea: [null, [customValidators.area9]],
    streetAddress: [null, [Validators.maxLength(100)]],
    totalSalesPrice: [null, [Validators.required, customValidators.price()]],
};


@Component({
    selector: 'app-real-estate-existing-building-quick-form',
    templateUrl: './real-estate-existing-building-quick-form.component.html',
    styleUrls: ['./real-estate-existing-building-quick-form.component.less']
})
export class RealEstateExistingBuildingQuickFormComponent implements OnInit, OnChanges {
    @Input() form: UntypedFormGroup;
    @Input() readonly: boolean;
    @Input() currency: string;

    public buildingTypes: Array<BuildingType>;
    public buildingTypeLabels: LabelsMap;
    public countries: any[] = [];

    constructor(
        public translationService: TranslationService,
    ) {
        this.buildingTypes = BuildingTypesQuickMode;
        this.buildingTypeLabels = this.translationService.inquiryBuildingTypesQuickMode;

        this.countries = this.translationService.inquiryRealEstateCountries;
    }

    ngOnChanges(changes: any) {
        if (changes.form) {
            this.updateCountryRelatedFields();
        }
    }

    ngOnInit() {
        this.form.get('country').valueChanges.subscribe(() => this.updateCountryRelatedFields() );
    }

    public updateCountryRelatedFields(): void {
        const country = this.form.get('country').value;

        const postCodeValidator = (country === 'GERMANY') ? customValidators.postalCodeOptionalValidator5 : customValidators.postalCodeOptionalValidator4;
        this.form.get('postalCode').setValidators([ postCodeValidator ]);
        this.form.get('postalCode').updateValueAndValidity();
    }

}
